import { render } from "./NSelectItems.vue?vue&type=template&id=6ed9a20a&ts=true"
import script from "./NSelectItems.vue?vue&type=script&lang=ts"
export * from "./NSelectItems.vue?vue&type=script&lang=ts"

import "./NSelectItems.vue?vue&type=style&index=0&id=6ed9a20a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__